import axios from 'axios';

class yczwServer{

  constructor() {
    this.$axios = axios;
  }


  //获取基地列表
  asyncDataApi(){
    return this.$axios({
      method: 'get',
      url:`/api/yczw/addAsyncData`,
    }).then((res) => {
       console.log(res,"获取基地列表");
       return res
    }).catch((error) => {
      console.log(error);
    });
  }


 //获取基地列表
  getBaseListApi(){
    return this.$axios({
      method: 'get',
      url:`/api/yczw/base/list`,
    }).then((res) => {
       console.log(res,"获取基地列表");
       return res
    }).catch((error) => {
      console.log(error);
    });
  }


  //获取基地列表
  getBaseListApi(){
    return this.$axios({
      method: 'get',
      url:`/api/yczw/base/list`,
    }).then((res) => {
       console.log(res,"获取基地列表");
       return res
    }).catch((error) => {
      console.log(error);
    });
  }

   //根据温室id 获取温室下面的所有的模块的列表
   getBaseIdByChannelIdApi(id){
    return this.$axios({
      method: 'get',
      url:`/api/yczw/base/id?id=${id}`,
    }).then((res) => {
       console.log(res,"获取模块列表");
       return res
    }).catch((error) => {
      console.log(error);
    });
  }





  //根据基地id所有的温室列表
  getHourseListApi(baseId){
    return this.$axios({
      method: 'get',
      url:`/api/yczw/hourse/list?baseId=${baseId}`,
    }).then((res) => {
       console.log(res,"获取温室列表");
       return res
    }).catch((error) => {
      console.log(error);
    });
  }


  //根据温室id 获取温室下面的所有的模块的列表
  getMoudelListApi(hourseId){
    return this.$axios({
      method: 'get',
      url:`/api/yczw/moudel/list?hourseId=${hourseId}`,
    }).then((res) => {
       console.log(res,"获取模块列表");
       return res
    }).catch((error) => {
      console.log(error);
    });
  }

  




}

export default new yczwServer();



// WEBPACK FOOTER //
// ./src/components/service/yczwServer.js